module.exports = __webpack_public_path__ + "img/preset1.72a4f3a2.png";